import styled from 'styled-components';

import { token } from '@zillow/constellation';

export const StyledPaymentError = styled.div`
  text-align: center;

  .PaymentError-header {
    color: white;
    background-color: ${token('colors.orangeRed400')};
    margin: 0px -16px;
  }

  .maintenanceMode {
    background-color: ${token('colors.yellow300')};
  }
`;
